import Button from "olive-react-myoneui/lib/Button";
import Card from "olive-react-myoneui/lib/Card";

const clickExplore = (e) => {
  e.preventDefault();
  window.location.replace('/course/listing');
}
function NoItemsInfo({
  className, itemType
}) {
  return (
    <Card className={`${className || ""} empty-block-card`}>
      <Card.Body className="p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
        <div className="empty-block">
          <h6><strong>Let’s begin learning!</strong></h6>
          <p>When you enroll in a {itemType === 'course' ? 'course' : 'program'}, it will appear here.</p>
          {itemType === 'course' && (
          <Button variant="secondary" onClick={clickExplore}>Explore courses</Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default NoItemsInfo;
